import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import PresentationSection from "./components/PresentationSection";
import SquadsSection from "./components/SquadsSection";
import EventsSection from "./components/EventsSection";
import ChallengesSection from "./components/ChallengesSection";
import FitnessTracker from "./components/FitnessTracker";
import NewsSection from "./components/NewsSection";
import CommunitySection from "./components/CommunitySection";
import BureauSection from "./components/BureauSection";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <PresentationSection />
        <SquadsSection />
        <EventsSection />
        <ChallengesSection />
        <FitnessTracker />
        <NewsSection />
        <CommunitySection />
        <BureauSection />
      </main>
      <Footer />
    </div>
  );
}
